module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Watch2-e9a2a59874aa991d3fbf25dd22323746.svg";